import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userData",
  initialState: {
    isLogin: false,
    data: {},
    listPermission: [],
    listMenu: [],
    isConfirmUser: false,
  },
  reducers: {
    setUserInfo(state, action) {
      state.data = action.payload;
    },
    setCurrentPermission(state, action) {
      state.listPermission = action.payload;
    },
    setIsLogin(state, action) {
      state.isLogin = action.payload;
    },
    setIsConfirmUser(state, action) {
      state.isConfirmUser = action.payload;
    },
    setListMenu(state, action) {
      state.listMenu = action.payload;
    },
  },
});
const { actions, reducer } = userSlice;
export const {
  setUserInfo,
  setIsLogin,
  setCurrentPermission,
  setIsConfirmUser,
  setListMenu
} = actions;
export default reducer;
